//import logo from './logo.svg';
import './App.css';

import { Admin, Resource } from 'react-admin';
import { QueryClient } from '@tanstack/react-query';
import dataProvider from './Providers/dataProvider';
import authProvider from './Providers/authProvider';

import { Dashboard } from './Pages';
import { AppLayout, appTheme, appDarkTheme } from './Layout';
import {
	User,
	Orb,
	Voice,
	Group,
	Library,
	Topic,
	Document
} from './Resources';

// Configure QueryClient with reduced cache time for better status updates
const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 60 * 1000, // 1 minute (default is 5 minutes)
			refetchOnWindowFocus: true,
		},
	},
});

function App() {

	return (
		<Admin
			dashboard={Dashboard}
			dataProvider={dataProvider}
			authProvider={authProvider}
			queryClient={queryClient}
			layout={AppLayout}
			theme={appTheme}
			darkTheme={appDarkTheme}
			disableTelemetry
			requireAuth
			>
			<Resource name="orbs" {...Orb} />
			<Resource name="voices" {...Voice} />
			<Resource name="users" {...User} />
			<Resource name="groups" {...Group} />
			<Resource name="libraries" {...Library} />
			<Resource name="topics" {...Topic} />
			<Resource name="documents" {...Document} />

		</Admin>
	);
}

export default App;
